var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransparentPriceIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 64,
    viewBox: "0 0 63 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.4252 32.1601C54.4252 44.8782 44.1033 55.2001 31.3852 55.2001C18.6671 55.2001 8.34521 44.8782 8.34521 32.1601C8.34521 19.442 18.6671 9.12012 31.3852 9.12012",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0224 24.8301H29.337C27.3468 24.8301 25.7354 26.4416 25.7354 28.4294C25.7354 30.4195 27.3468 32.0311 29.337 32.0311H33.4519C35.4395 32.0311 37.051 33.6426 37.051 35.6302C37.051 37.6203 35.4395 39.2318 33.4519 39.2318H26.7642",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.395 39.2305V42.2544M31.395 21.79V24.8388",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8755 6.15527C51.982 8.75172 55.5449 8.59064 56.5651 8.59064C56.3389 23.3524 54.6283 20.4262 48.8755 24.5643C43.1227 20.4262 41.416 23.3524 41.2051 8.59064C42.1984 8.59064 45.7613 8.75172 48.8755 6.15527Z",
    fill: "#26B8E3",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparentPriceIcon);
export default __webpack_public_path__ + "static/media/transparentPriceIcon.628d8f813c5359c405c5e234abb90583.svg";
export { ForwardRef as ReactComponent };